import { render, staticRenderFns } from "./OrderCreate.vue?vue&type=template&id=9d3d562e&"
import script from "./OrderCreate.vue?vue&type=script&lang=ts&"
export * from "./OrderCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports